import React from "react";

function Logo() {
    return (
        <div className="container-fluid navbar-container">
            <span className="navbar-brand">
                &lt;SoftControl/&gt;
                <br />
                <span className="motto"> Crafting tomorrow's Code today</span>
            </span>
        </div>
    );
}

export default Logo;
